
/**
 * @class
 * @description Model for the place to display on map
 * 
 */
 export class Place {

    /**
     * 
     * @param {string} name Label name
     * @param {number} url Background image URL
     * @param {[number, number][]} cornersCoords Image corners coordinates ([[bottom_left_lat,bottom_left_lon],[top_left_lat,top_left_lon],[top_right_lat,top_right_lon],[bottom_right_lat,bottom_right_lon]])
     * @param {[number, number][]} bounds Bounds to fit when place is selected([[bottom_left_lat,bottom_left_lon],[top_left_lat,top_left_lon],[top_right_lat,top_right_lon],[bottom_right_lat,bottom_right_lon]]) (optional)
     * @param {number} zoom Zoom to apply when place is selected (optional)
     */
    constructor(name, url, cornersCoords, bounds, zoom) {
        this.name = name;
        this.url = url;
        this.cornersCoords = cornersCoords;
        this.bounds = bounds;
        this.zoom = zoom;
    }
}  